import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "@i18n";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import { Link } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import { CDN_LINK } from "@globalConfig";
import useIsMobile from "@hooks/useIsMobile";
import { trackEvents } from "@/common/events/events";
var SearchByMake = function SearchByMake(_ref) {
  var carMakes = _ref.carMakes;
  var _useTranslation = useTranslation(["web_home"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    label = _useHelpers.label;
  var _useState = useState(false),
    showAllMakes = _useState[0],
    setShowAllMakes = _useState[1];
  var numberOfModelsDefault = 9;
  var isMobile = useIsMobile();
  var createLink = function createLink(item) {
    var _item$name_en;
    return createUrl("/autos/".concat(item === null || item === void 0 ? void 0 : (_item$name_en = item.name_en) === null || _item$name_en === void 0 ? void 0 : _item$name_en.slugify()), {}, {
      referral_location: "Home",
      browse_variant: "make",
      variant_value: item.name_en
    });
  };
  if (carMakes.length === 0) return;
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-8",
    id: "browse-by-brand-section"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-[#154F9C] text-lg font-bold leading-[32px] md:text-xl min-h-[32px]"
  }, t("تصفح السيارت حسب الماركة", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("div", {
    id: "brands-container",
    className: "flex gap-[12px] flex-wrap mt-4 max-md:flex-nowrap max-md:overflow-x-scroll max-md:-mx-4 max-md:px-4"
  }, carMakes.map(function (make, index) {
    return /*#__PURE__*/React.createElement(Link, {
      key: index,
      to: createLink(make),
      className: ["w-[calc(88px)] flex justify-center items-center flex-col", !isMobile && !showAllMakes && index + 1 > numberOfModelsDefault ? "hidden" : undefined].join(" "),
      "aria-label": make.name,
      id: "autos-link-".concat(index)
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full h-[56px] rounded-[5px] bg-[#FAFAFA] relative flex justify-center items-center overflow-hidden max-md:w-[80px] max-md:h-[56px]"
    }, /*#__PURE__*/React.createElement(ProgressiveImage, {
      waitUntilInteractive: true,
      fetchpriority: "low",
      width: 90,
      height: 90,
      src: make.logo,
      alt: make.name,
      loading: "lazy",
      className: "w-[50%] object-contain"
    })), /*#__PURE__*/React.createElement("h3", {
      className: "mt-[8px] text-[#484848] text-center text-sm font-normal leading-[16px] min-h-[16px]"
    }, label(make)));
  }), /*#__PURE__*/React.createElement("a", {
    href: createUrl("/autos/used-cars"),
    onClick: function onClick() {
      trackEvents("browse_cars", {
        referral_location: "home",
        browse_variant: "make",
        variant_value: "all_makes_used",
        category_path: null
      });
    },
    className: ["w-[calc(88px)] flex justify-start items-center flex-col", !isMobile && !showAllMakes ? "hidden" : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full h-[56px] rounded-[5px]  relative flex justify-center items-center overflow-hidden max-md:w-[90px] max-md:h-[56px] max-md:mt-[10px]"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#154F9C] text-sm font-semibold leading-5"
  }, t("جميع السيارات المستعملة", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("img", {
    className: ["transform ar:[transform:rotateY(180deg)]"].join(" "),
    src: CDN_LINK + "/assets/images/blue-arrow.svg",
    width: 24,
    height: 24,
    alt: "arrow"
  }))), /*#__PURE__*/React.createElement("a", {
    href: createUrl("/autos/new-cars"),
    onClick: function onClick() {
      trackEvents("browse_cars", {
        referral_location: "home",
        browse_variant: "make",
        variant_value: "all_makes_new",
        category_path: null
      });
    },
    className: ["w-[calc(88px)] flex justify-start items-center flex-col", !isMobile && !showAllMakes ? "hidden" : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full h-[56px] rounded-[5px]  relative flex justify-center items-center overflow-hidden max-md:w-[80px] max-md:h-[56px] max-md:mt-[10px]"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#154F9C] text-sm font-semibold leading-5"
  }, t("جميع السيارات الجديدة", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("img", {
    className: ["transform ar:[transform:rotateY(180deg)]"].join(" "),
    src: CDN_LINK + "/assets/images/blue-arrow.svg",
    width: 24,
    height: 24,
    alt: "arrow"
  }))), /*#__PURE__*/React.createElement("a", {
    href: createUrl("/autos"),
    onClick: function onClick() {
      trackEvents("browse_cars", {
        referral_location: "home",
        browse_variant: "make",
        variant_value: "all_makes",
        category_path: null
      });
    },
    className: ["w-[calc(88px)] flex justify-start items-center flex-col", !isMobile && !showAllMakes ? "hidden" : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full h-[56px] rounded-[5px]  relative flex justify-center items-center overflow-hidden max-md:w-[80px] max-md:h-[56px] max-md:mt-[10px]"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#154F9C] text-sm font-semibold leading-5"
  }, t("جميع السيارات", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("img", {
    className: ["transform ar:[transform:rotateY(180deg)]"].join(" "),
    src: CDN_LINK + "/assets/images/blue-arrow.svg",
    width: 24,
    height: 24,
    alt: "arrow"
  })))), !isMobile && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center mt-4 w-full mt-7"
  }, /*#__PURE__*/React.createElement("span", {
    id: "show-all-makes",
    onClick: function onClick() {
      return setShowAllMakes(!showAllMakes);
    },
    className: "flex items-center justify-center text-[#154F9C] text-center text-sm font-bold leading-[16px] cursor-pointer"
  }, !showAllMakes ? t("شاهد جميع الماركات", {
    ns: "web_home"
  }) : t("عرض أقل", {
    ns: "web_home"
  }), /*#__PURE__*/React.createElement("img", {
    className: ["transition duration-300", !showAllMakes ? "rotate-90" : "-rotate-90"].join(" "),
    src: CDN_LINK + "/assets/images/blue-arrow.svg",
    width: 24,
    height: 24,
    alt: "arrow"
  }))));
};
export default SearchByMake;